const styles = {
  root: {
    marginY: 1,
    backgroundColor: 'background.default',
  },

  rating: {
    backgroundColor: 'background.grey450',
    border: 'none',
    textAlign: 'left',
  },

  title: {
    marginY: 2,
    '&.MuiTypography-h3': {
      color: 'secondary.main',
    },
  },
  gridContainer: {
    paddingX: { xs: 0, lg: 2 },
    paddingTop: 2,
    backgroundColor: 'background.default',
    '&.MuiGrid2-root': {
      paddingBottom: '0px!important',
    },
  },

  gridItem: {
    padding: 1,
    backgroundColor: 'background.grey450',
    borderRadius: '2px',
  },
  gridItemVariant: {
    borderRadius: '2px',
  },

  ratingContainer: {
    border: 'none',
    justifyContent: 'flex-start',
  },
  item: {
    justifyContent: 'center',
    display: 'flex',
    marginBottom: 2,
    position: 'relative',
    height: 50,
    mr: 1,
  },
}

export default styles
